import { render, staticRenderFns } from "./efficiency_classes.vue?vue&type=template&id=2b2370c4&scoped=true&lang=html"
import script from "./efficiency_classes.vue?vue&type=script&lang=js"
export * from "./efficiency_classes.vue?vue&type=script&lang=js"
import style0 from "./efficiency_classes.vue?vue&type=style&index=0&id=2b2370c4&prod&lang=css"
import style1 from "./efficiency_classes.vue?vue&type=style&index=1&id=2b2370c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2370c4",
  null
  
)

export default component.exports